import { createFileRoute } from '@tanstack/react-router';
import {
  AnalyticsInventoryPage,
  analyticsInventoryQueryOptions,
  analyticsLoaderDeps,
} from '@/features/analytics';
import { useAuthStore } from '@/stores/auth';

export const Route = createFileRoute('/_authed/analytics/inventory')({
  loaderDeps: ({ search }) => analyticsLoaderDeps(search),
  loader: ({ context, deps }) => {
    const activeBranchId = useAuthStore.getState().activeBranchId;
    const branchId = activeBranchId && activeBranchId !== 'all' ? activeBranchId : undefined;

    void context.queryClient.prefetchQuery(
      analyticsInventoryQueryOptions({
        period: deps.period,
        branch_id: branchId,
      }),
    );
  },
  component: AnalyticsInventoryPage,
});
